import { Map } from 'immutable';
import { myRemoveEntities, myRemoveEntitiesBySport } from './utils';
import { LIVE_INIT, LIVE_UPDATE, LIVE_MATCH_UPDATE, LIVE_MATCH_INIT } from '../../sagas/actions';
import * as PopularActions from '../../actions/popular';
import * as LineActions from '../../actions/lines';
import * as LiveActions from '../../actions/live';
export default function ratesReducer(rates, action) {
    switch (action.type) {
        case PopularActions.CLEAR_POPULAR:
        case LineActions.CLEAR_LINE:
        case LiveActions.CLEAR_LIVE:
        case LiveActions.CLEAR_LIVE_MATCH:
            return Map();
        case LIVE_INIT.SUCCESS:
        case LIVE_MATCH_INIT.SUCCESS:
        case LineActions.SUCCESS_FETCH_LINE_HEADERS:
        case LineActions.SUCCESS_FETCH_SPORT_LINE_HEADERS:
        case LineActions.SUCCESS_FETCH_LEAGUE_LINE_HEADERS:
        case PopularActions.SUCCESS_FETCH_POPULAR_MATCHES:
            return init(new Map(), action.data);
        case LineActions.SUCCESS_FETCH_FULL_LINE:
            var matches = action.data.events.add.map(function (m) { return { id: m.id }; });
            rates = myRemoveEntities(rates, 'matchId', matches);
            return init(rates, action.data);
        case LIVE_UPDATE.SUCCESS:
        case LIVE_MATCH_UPDATE.SUCCESS:
            return update(rates, action.data);
        default:
            return rates;
    }
}
function init(rates, data) {
    if (data.rates !== undefined) {
        rates = addRates(rates, data.rates.add);
    }
    if (data.blocked_events !== undefined && data.blocked_events.add !== undefined) {
        rates = updateRatesBlock(rates, 'matchId', data.blocked_events.add, true);
    }
    if (data.blocked_outcomes !== undefined && data.blocked_outcomes.add !== undefined) {
        rates = updateRatesBlock(rates, 'outcomeId', data.blocked_outcomes.add, true);
    }
    return rates;
}
function update(rates, data) {
    if (data.sports !== undefined && data.sports.remove !== undefined) {
        rates = myRemoveEntitiesBySport(rates, 'sportId', data.sports.remove);
    }
    if (data.leagues !== undefined && data.leagues.remove !== undefined) {
        rates = myRemoveEntities(rates, 'leagueId', data.leagues.remove);
    }
    if (data.events !== undefined && data.events.remove !== undefined) {
        rates = myRemoveEntities(rates, 'matchId', data.events.remove);
    }
    if (data.outcomes !== undefined && data.outcomes.remove !== undefined) {
        rates = myRemoveEntities(rates, 'outcomeId', data.outcomes.remove);
    }
    if (data.rates !== undefined) {
        if (data.rates.add !== undefined) {
            rates = addRates(rates, data.rates.add);
        }
        rates = changeRates(rates, data.rates.change);
    }
    if (data.blocked_events !== undefined) {
        rates = updateRatesBlock(rates, 'matchId', data.blocked_events.add, true);
        rates = updateRatesBlock(rates, 'matchId', data.blocked_events.remove, false);
    }
    if (data.blocked_outcomes !== undefined) {
        rates = updateRatesBlock(rates, 'outcomeId', data.blocked_outcomes.add, true);
        rates = updateRatesBlock(rates, 'outcomeId', data.blocked_outcomes.remove, false);
    }
    return rates;
}
function addRates(rates, addRates) {
    if (addRates === undefined) {
        return rates;
    }
    return rates.withMutations(function (r) {
        for (var i = 0; i < addRates.length; i++) {
            var addRate = addRates[i];
            if (addRate === undefined || addRate.outcomeId === undefined) {
                throw new Error('Add rate: parent key not found');
            }
            var plainRate = Object.assign({}, addRate, {
                isVisible: addRate.value > 1,
                isBlocked: false
            });
            var rate = new Map(plainRate);
            r.set(addRate.id, rate);
        }
    });
}
function changeRates(rates, changeRates) {
    if (changeRates === undefined) {
        return rates;
    }
    for (var rateId in changeRates) {
        if (!changeRates.hasOwnProperty(rateId)) {
            continue;
        }
        (function (rateId, value) {
            rates = rates.update(parseInt(rateId), function (r) {
                if (r === undefined) {
                    throw new Error('Rate#' + rateId + 'not present in state, but change received');
                }
                return r.set('value', value).set('isVisible', value > 1);
            });
        })(rateId, changeRates[rateId]);
    }
    return rates;
}
function updateRatesBlock(entities, field, values, isBlocked) {
    if (values === undefined) {
        return entities;
    }
    var affectedIds = entities.valueSeq()
        .filter(function (m) { return values.indexOf(m.get(field)) !== -1; })
        .map(function (m) { return m.get('id'); })
        .toArray();
    entities = entities.withMutations(function (e) {
        for (var j = 0; j < affectedIds.length; j++) {
            var id = affectedIds[j];
            e.setIn([id, 'isBlocked'], isBlocked);
        }
    });
    return entities;
}



// WEBPACK FOOTER //
// ./src/reducers/entities/ratesReducer.js